<template>
  <div>
    <breadcrumbs></breadcrumbs>
    <div class="ind-title lh50 f16">
      <!-- <i class="el-icon-loading"></i> -->
      消息详情
    </div>

    <div class="a">发送人：{{ sendName.sendName }}</div>

    <div v-if="arr.recType == 0">接收终端：总平台</div>
    <div v-if="arr.recType == 1">接收终端：微信用户</div>
    <div v-if="arr.recType == 2">
      接收终端： 回收站
    </div>
    <div v-if="arr.recType == 3">接收终端：仓库</div>
    <div v-if="arr.recType == 4">接收终端：运营</div>

    <div class="a">接收主体：{{ sendName.rname }}</div>

    <div class="a">消息标题：{{ arr.title }}</div>

    <div class="a">消息详情：<span v-html="arr.content"></span></div>

    <div class="a">发送时间：{{ arr.createTime }}</div>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";

export default {
  components: {
    breadcrumbs,
  },
  data() {
    return {
      arr: "",
      sendName: "",
    };
  },
  created() {
    this.getSendMessageDetail();
  },

  methods: {
    getSendMessageDetail() {
      this.$api.activitymsg
        .getSendMessageDetail({
          messageId: this.$route.query.id,
        })
        .then((e) => {
          this.arr = e.data.ifno;
          this.sendName = e.data;
        });
    },
  },
};
</script>

<style scoped>
.a {
  margin: 20px 0;
}
</style>
